import { Http } from 'packages/workspace/modules/prelude/http';
import type { IOnlineUser } from 'packages/workspace/services/models/account';
import { InternalConversationStore } from 'packages/workspace/services/store/omnichannel/internal-conversation-store';
import { UseInfiniteQueryResult,UseMutationResult,useMutation, UseQueryResult, useInfiniteQuery, useQuery, useQueryClient } from 'react-query';
import type { ResponseFormat } from '../../../services/models/global-models';
import type { IHTTPConversation } from '../../../services/models/internal-channel';
import useSession from '../../../services/store/session-store';

const fetchConversation = async (recipientId: string): Promise<IHTTPConversation> =>
  Http.Request<ResponseFormat<IHTTPConversation>>('GET', `/workspaces/api/v1/conversations.get?receiver=${recipientId}`).then((res) => res.data);

//!Setting Stale time inifinity - so it only gets populated in REFRESH
export default function useGetConversation(recipientId: string): UseQueryResult<IHTTPConversation> {
  const session = useSession();
  const queryClient = useQueryClient();
  return useQuery(
    ['allConversations', recipientId],
    () =>
      fetchConversation(recipientId).then((convResponse: IHTTPConversation) => {
        const oldData = queryClient.getQueryData<IOnlineUser[]>(['onlineUsers']);
        const userDoesNotHaveConvId = (oldData ?? []).find((e) => e.id === recipientId && !e.conversation_id);
        if (userDoesNotHaveConvId) {
          queryClient.setQueryData<IOnlineUser[]>(['onlineUsers'], (prevOnlineUsers) => {
            if (prevOnlineUsers === undefined) prevOnlineUsers = [] as IOnlineUser[];
            return prevOnlineUsers.map((entity: IOnlineUser) => {
              if (entity.id === recipientId && !entity.conversation_id) {
                entity = {
                  ...entity,
                  conversation_id: convResponse.conversation_id,
                };
              }
              return entity;
            });
          });
        }
        return Promise.resolve(convResponse);
      }),
    {
      enabled: recipientId !== '' && Boolean(session.cognitoUser && session.discoveryParams),
      staleTime: Number.POSITIVE_INFINITY,
      onSuccess: (data) => InternalConversationStore.updateBulkMessages(data.conversation_id, data.messages),
    }
  );
}

export function useGetPastConversation(recipientId: string, start: string, enabled = false): UseInfiniteQueryResult<IHTTPConversation> {
  const session = useSession();
    return useInfiniteQuery(
      ['allPastConversations', recipientId],
      ({ pageParam = null }) => Http.Request('GET', `/workspaces/api/v1/conversation-history.get?receiver=${recipientId}&start=${pageParam || start}`),
      {
        enabled: enabled && recipientId !== '' && recipientId !== undefined && Boolean(session.cognitoUser && session.discoveryParams),
        getNextPageParam: (lastPage) => (lastPage.length > 0 ? lastPage[0].timestamp : null),
          staleTime: Number.POSITIVE_INFINITY,
          onSuccess: ({pages}) => InternalConversationStore.updateInfiniteBulkMessages(pages[pages.length - 1].data.conversation_id, pages[pages.length - 1].data.messages)
      }
    );
  }

export function useStaffChatMuteOption(): UseMutationResult<string, unknown, { accountId: string; enabled: boolean }, unknown> {
  return useMutation(
    async ({ accountId, enabled }) =>
      Http.Request<ResponseFormat<string>>('POST', `/workspaces/api/v1/account-notification.mute?acc_id=${accountId}&mute_notification=${enabled}`).then((res) => res.data),
    {
      onError: async (error: any) => {
        const err = await error;
        return err.errors;
      },
    }
  );
}
